import { Link } from "react-router-dom";
import { GameStory } from "../components/GameStory";
import { GrimoireTable } from "../components/InfoView";
import { PhaseHeader } from "../components/PhaseHeader";
import { useCommand } from "../hooks/useCommand";
import type { PlayerView } from "../protocol";
import { isHost, seatName } from "../state/selectors";
import { useGame } from "../state/store";

export function GameOverScreen({ view }: { view: PlayerView }) {
  const roles = useGame((s) => s.roles);
  const { run, busy } = useCommand();
  const over = view.game_over;
  if (!over) return null;
  const good = over.winner === "good";
  const mine = view.private.alignment;
  // the host ended the game: nobody won or lost
  const won = mine && over.winner ? mine === over.winner : null;
  const headline = over.winner === null ? "Game ended" : good ? "Good wins" : "Evil wins";

  return (
    <main className="screen">
      <PhaseHeader view={view} roles={roles} showRole={false} />
      <section className={`card stack center winner winner-${over.winner ?? "none"}`}>
        <span className="eyebrow">Game over</span>
        <h1 className={over.winner ?? undefined}>{headline}</h1>
        <p>{over.reason_text}</p>
        {won !== null && <p className="small muted">{won ? "You won." : "You lost."}</p>}
      </section>

      <section className="stack-sm">
        <h3>The Grimoire</h3>
        <GrimoireTable grimoire={over.grimoire} roles={roles} icons />
      </section>

      <GameStory story={over.story} />

      <div className="grow" />
      <div className="bottom-bar">
        {isHost(view) ? (
          <button
            className="btn btn-primary"
            disabled={busy}
            onClick={() => run({ type: "play_again", seed: null })}
          >
            Play again with this table
          </button>
        ) : (
          <p className="muted center">
            {seatName(view, view.host_seat_id)} can start another game.
          </p>
        )}
        <Link className="btn btn-ghost" to="/">
          Leave
        </Link>
      </div>
    </main>
  );
}
